<template>
  <div class="app flex-row align-items-center login-bg">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card
              no-body
              class="text-white bg-primary py-5 d-md-down-none"
              style="width: 44%"
            >
              <b-card-body class="text-center">
                <div>
                  <h2>디엠씨리포트</h2>
                  <p>디엠씨리포트 관리자 시스템</p>
                  <!-- <b-button variant="primary" class="active mt-3">Register Now!</b-button> -->
                </div>
              </b-card-body>
            </b-card>
            <b-card no-body class="p-4">
              <b-card-body>
                <h1>Login</h1>
                <p class="text-muted">{{ msg }}</p>
                <b-input-group class="mb-3">
                  <b-input-group-prepend
                    ><b-input-group-text><i class="icon-user"></i></b-input-group-text
                  ></b-input-group-prepend>
                  <input
                    type="text"
                    v-model="userId"
                    class="form-control"
                    placeholder="UserId"
                  />
                </b-input-group>
                <b-input-group class="mb-4">
                  <b-input-group-prepend
                    ><b-input-group-text><i class="icon-lock"></i></b-input-group-text
                  ></b-input-group-prepend>
                  <input
                    type="password"
                    v-model="password"
                    class="form-control"
                    placeholder="Password"
                    @keyup.enter="loginSubmit(userId, password)"
                  />
                </b-input-group>
                <b-row>
                  <b-col cols="6">
                    <b-button
                      variant="primary"
                      v-on:click="loginSubmit(userId, password)"
                      class="px-4"
                      >Login</b-button
                    >
                  </b-col>
                  <b-col cols="6" class="text-right">
                    <!-- <b-button variant="link" class="px-0">Forgot password?</b-button> -->
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
// import axios from 'axios'
// import swal from 'sweetalert2'

export default {
  name: "Login",
  data() {
    return {
      userId: "",
      password: "",
      msg: "Sign In to your account",
      localIP: "",
    };
  },
  mounted: function () {},
  methods: {
    loginSubmit(userId, password) {
      var params = "grant_type=password&username=" + userId + "&password=" + password;
      this.loginProc(params);
    },
    loginProc(params) {
      var self = this;
      
      // 표준 OAuth2 흐름: /oauth/token으로 직접 토큰 발급 요청
      this.$http
        .post("/oauth/token", params, {
          headers: {
            "Content-type": "application/x-www-form-urlencoded",
            "Authorization": self.$store.getters.getCredentialCode
          },
          // 브라우저 Basic Auth 팝업 방지
          validateStatus: function (status) {
            return status >= 200 && status < 500;
          }
        })
        .then((tokenResult) => {
          // OAuth 토큰 요청 실패 체크
          if (tokenResult.status !== 200) {
            var errorMsg = '로그인에 실패했습니다.';
            if (tokenResult.data) {
              if (tokenResult.data.error_description) {
                errorMsg = tokenResult.data.error_description;
              } else if (tokenResult.data.message) {
                errorMsg = tokenResult.data.message;
              }
            }
            throw new Error(errorMsg);
          }
          
          // 토큰 발급 성공
          console.log('OAuth token result:', tokenResult.data);
          
          // 토큰을 먼저 sessionStorage에 저장 (이후 API 요청에 사용)
          var accessToken = tokenResult.data.access_token;
          sessionStorage.setItem("myToken", accessToken);
          
          // 토큰이 저장된 후에 유저 정보 조회 (Bearer 토큰 사용)
          return self.$http.get("/select/user", {
            params: {
              username: self.userId
            }
          }).then((resultUser) => {
            if (resultUser.status !== 200) {
              throw new Error('사용자 정보를 가져올 수 없습니다.');
            }
            return {
              token: tokenResult.data,
              user: resultUser.data
            };
          });
        })
        .then((data) => {
          // 세션 시작 및 유저 정보 저장
          self.$session.start();
          self.$session.set("userId", self.userId);
          self.$session.set("userInfo", data.user);
          
          // Vuex 스토어에 로그인 정보 저장
          self.$store.dispatch("LOGIN", data);
          
          // 대시보드로 리다이렉트
          self.$router.push("/dashboard");
        })
        .catch((error) => {
          console.error('Login error:', error);
          
          // 로그인 실패 시 토큰 제거
          sessionStorage.removeItem("myToken");
          
          if (error.message) {
            self.msg = error.message;
            if (error.message.includes('Bad credentials')) {
              self.msg = '아이디 또는 비밀번호가 일치하지 않습니다.';
            }
          } else if (error.response && error.response.data) {
            if (error.response.data.error_description) {
              self.msg = error.response.data.error_description;
            } else if (error.response.data.message) {
              self.msg = error.response.data.message;
            } else {
              self.msg = "로그인 중 오류가 발생했습니다.";
            }
          } else {
            self.msg = "로그인 중 오류가 발생했습니다.";
          }
        });
    },
  },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/views/pages/Login.vue